export const paperworkAddressRequiredFields = {
  address: 'DOSSIER_COMPONENTS.VALIDATIONS.PAPERWORK_ADDRESS_ADDRESS',
  city: 'DOSSIER_COMPONENTS.VALIDATIONS.PAPERWORK_ADDRESS_CITY',
  state: 'DOSSIER_COMPONENTS.VALIDATIONS.PAPERWORK_ADDRESS_STATE',
  cp: 'DOSSIER_COMPONENTS.VALIDATIONS.PAPERWORK_ADDRESS_CP'
}
